import type {
  MessagingProtectionApiResponse,
  MessagingProtectionResponse,
  MessagingIntentResponse,
} from '@/types/Api/MessagingProtection'
import type { MessagingIntent } from '@/types/Models/MessagingProtection'

export default class MessagingProtectionTransformer {
  static intent(data: MessagingIntentResponse): MessagingIntent {
    return {
      id: data.id,
      releaseId: data.release_id,
      channel: data.channel,
      template: data.template,
      shipmentNumber: data.shipment_number,
      companyId: data.company_id,
      status: data.status,
      reason: data.reason,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
    }
  }

  static fetch(data: MessagingProtectionApiResponse): MessagingProtectionResponse {
    return {
      timezone: data.timezone ?? 'UTC',
      mailerReadyForSeconds: data.mailer_ready_for_seconds ?? 0,
      enabled: data.enabled,
      ruleVersion: data.rule_version,
      volumePolicy: data.volume_policy,
      state: data.state && !Array.isArray(data.state)
        ? {
            mailerSeenAt: data.state.mailer_seen_at,
            schedulerSeenAt: data.state.scheduler_seen_at,
            mailerPending: data.state.mailer_pending,
          }
        : null,
      releases: data.releases.map((release) => ({
        id: release.id,
        repository: release.repository,
        sha: release.sha,
        createdAt: release.created_at,
        deployedAt: release.deployed_at,
        schedulerObserved: release.scheduler_observed,
        status: release.status,
        counts: release.counts,
        baseline: release.baseline.map((row) => ({
          type: row.type,
          eventType: row.event_type,
          attempts: row.attempts,
          activeDays: row.active_days,
        })),
      })),
      intents: { data: data.intents.data.map(this.intent), count: data.intents.total },
    }
  }
}
